<div class="assignment-crates">
  <div class="content">
    <div class="assignment-section">
      <dx-data-grid
        id="loadunits-grid"
        [dataSource]="crates()"
        keyExpr="StockLogArticleNo"
        [showRowLines]="true"
        [showColumnLines]="false"
        [showBorders]="false"
        [allowColumnReordering]="false"
        [allowColumnResizing]="false"
        style="width: 100%"
        height="100%">
        <dxo-paging [pageSize]="120"></dxo-paging>
        <dxo-scrolling
          mode="infinite"
          [useNative]="false"
          [scrollByContent]="true"
          [scrollByThumb]="true"
          showScrollbar="onHover">
        </dxo-scrolling>
        <dxi-column
          dataField="Description"
          [allowSorting]="false"
          [caption]="'ASSIGNMENT.CRATE.DESCRIPTION' | translate"
          alignment="center"></dxi-column>
        <dxi-column
          dataField="StockLogArticleNo"
          [allowSorting]="false"
          [caption]="'ASSIGNMENT.CRATE.STOCKLOGARTICLENO' | translate"
          alignment="center"></dxi-column>
        <dxi-column
          dataField="CrateNo"
          [allowSorting]="false"
          [caption]="'ASSIGNMENT.CRATE.CRATENO' | translate"
          alignment="center"></dxi-column>
        <dxi-column
          dataField="PackagingUnit"
          [allowSorting]="false"
          [caption]="'ASSIGNMENT.CRATE.PACKUNIT' | translate"
          alignment="center"></dxi-column>
      </dx-data-grid>
    </div>
  </div>
</div>
